export default __webpack_public_path__ + "static/AWS_Classroom1-dbf31f3274ede85c5f81c1c5b09f19b0.jpg";